import React from 'react';
import { ReactComponent as WarningIcon } from '../../assets/img/icons/assistant/Warning.svg';

const AIAssistantWarning = () => {
  return (
    <div className="ai-assistant-status">
      <WarningIcon />
      <div className="ai-assistant-status-text">Re-establishing connection. Please standby...</div>
    </div>
  );
};

export default AIAssistantWarning;
